import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/Icon';
import PublicNavbar from '../components/PublicNavbar';
import { trackEvent } from '../utils/analytics';

// Mock data för terapeuter - kommer senare att hämtas från backend
const therapists = [
  {
    id: 1,
    slug: "jenny-fuxe",
    name: "Jenny Fuxe",
    title: "Legitimerad Psykoterapeut",
    specialties: ["Schematerapi", "KBT", "Relationsterapi"],
    shortBio: "Jenny är specialist på Schematerapi och KBT med fokus på relationella problem och anknytning.",
    image: "/images/jenny-fuxe.jpg",
    experience: "10+ år",
    education: "Leg. Psykoterapeut",
    languages: ["Svenska"],
    longBio: `Vad älskar du mest med att vara terapeut?

Att uppleva människors förändring. Jag har alltid varit fascinerad av mänskligt beteende och de komplexa mekanismer som styr våra liv. Min nyfikenhet har drivit mig att utforska varför vi utvecklar olika sidor av oss själva, varför vi visar upp vissa och döljer andra.

Jag jobbar mycket med affektbryggor mellan nu och då. Varför vi t ex triggas starkt känslomässigt i en situation idag och kanske vill fly beror ofta på att gamla sår aktiveras. Detta behöver vi förstå för att kunna läka. Som schematerapeut är mitt fokus just detta. Vi undersöker tillsammans om det finns frustrerade behov från barndomen. Känslomässiga behov som vi alla har när vi växer upp är t ex att bli sedda, hörda, speglade i våra känslor, känna oss trygga och inkluderade. Vi behöver också empatisk gränssättning och lekfullhet. Om vi har med oss frustrationer t ex varit oskyddade, övergivna känslomässigt, mobbade för att ge några ex kan vi utveckla känslomässiga sår. Ofta har vi starka skyddssidor på grund av detta.

Som psykoterapeut är jag engagerad och nyfiken. Det kan vara tufft att gå i terapi men det ska vara spännande och roligt också. Det är ett detektivarbete vi gör tillsammans.

Om mig:
Jag är leg psykoterapeut med inriktning på Kognitiv Beteendeterapi (KBT) och Schematerapi, en mer fördjupande terapiform med mer fokus på uppväxterfarenheter och anknytning.

Jag har också utbildning i EFT, emotional focused therapy med inriktning mot par.

Tidigare har jag varit verksam på Valsta VC, en vårdcentral i Sigtuna som KBT-terapeut. Jag har också jobbat på Egil Linges relationsmottagning under 5 år.

Idag jobbar jag helt och hållet privat och driver egen mottagning på Riddargatan på Östermalm.

Jag har samarbeten med bland annat Stockholm Medical Office (en företagshälsovård), Trygghetsrådet och Svenska Kognitiva Institutet vid Sabbatsbergs sjukhus.

Jag jobbar med både enskilda och par, familjer och grupper.

Mina klienter söker ofta hjälp för relationella problem, låg självkänsla, ångest, nedstämdhet, självkritik, perfektionism och stress.

Att arbeta tillsammans:
Vi kommer tillsammans överens om var vi börjar varje session utifrån vad som känns mest angeläget, det som så att säga "ligger överst." Samtidigt som vi kopplar till föregående samtal och terapimål. Ibland ger jag hemuppgifter, men det passar inte alla.`,
    certifications: [
      "Legitimerad Psykoterapeut (Sverige)",
      "Specialist i Kognitiv Beteendeterapi (KBT)",
      "Utbildning i Schematerapi",
      "Certifierad i EFT (Emotional Focused Therapy)"
    ],
    approaches: [
      "Schematerapi",
      "Kognitiv Beteendeterapi (KBT)",
      "EFT (Emotional Focused Therapy)",
      "Relationsterapi",
      "Parterapi"
    ]
  },
  {
    id: 2,
    slug: "miriam-walden",
    name: "Miriam Walden",
    title: "Legitimerad Psykoterapeut & Certifierad Schematerapeut",
    specialties: ["Schematerapi", "KBT", "CFT", "ACT"],
    shortBio: "Miriam är legitimerad psykoterapeut och certifierad schematerapeut med bred klinisk erfarenhet från kris, trauma och relationssvårigheter.",
    image: "/images/miriam-walden.jpg",
    experience: "10+ år",
    education: "Lunds- och Stockholms Universitet",
    languages: ["Svenska", "Engelska"],
    longBio: `Jag är legitimerad Psykoterapeut samt certifierad Schematerapeut med flerårig erfarenhet av psykoterapeutiskt arbete med individer, par och familjer. Jag har bred klinisk erfarenhet från bland annat kris- och trauma, sorg, ätstörningar, neuropsykiatri, relationssvårigheter, stress och utmattning. 

Jag har varit verksam inom psykiatrin, som kurator i skolvärlden samt som psykoterapeut inom företagshälsovård och primärvård. Jag har arbetat i privat regi såväl som i offentlig verksamhet. Tidigare har jag också arbetat som organisationskonsult med stöd till chefer och ledningsgrupper samt med organisationsutveckling. 

Jag har min grundutbildning som Beteendevetare från Lunds- och Stockholms Universitet. För närvarande är jag verksam som privatpraktiserande kliniker och inom företagshälsovård.

Mitt arbete utgår från KBT och Schematerapi samt från CFT (Compassionfokuserad terapi) och ACT (Acceptance and Commitment therapy). Jag integrerar kunskap om meditation och mindfulness i det kliniska arbetet och i mötet med mig får de existentiella frågorna ofta betydande utrymme. Behandlingsmetoden anpassas efter dig och dina specifika behov och jag möter dig där du befinner dig. Vi utgår från livsteman varit svåra att förändra på egen hand.

Vanliga sökorsaker är emotionell instabilitet, kriser, relationssvårigheter, ångest/panikångest, depression, tvång, låg självkänsla och känslomässiga svårigheter.`,
    certifications: [
      "Legitimerad Psykoterapeut (Sverige)",
      "Certifierad Schematerapeut",
      "Beteendevetare från Lunds- och Stockholms Universitet",
      "Utbildning i CFT (Compassionfokuserad terapi)",
      "Utbildning i ACT (Acceptance and Commitment therapy)"
    ],
    approaches: [
      "Schematerapi",
      "Kognitiv Beteendeterapi (KBT)",
      "CFT (Compassionfokuserad terapi)",
      "ACT (Acceptance and Commitment therapy)",
      "Meditation och mindfulness",
      "Existentiell terapi"
    ]
  }
];

const TherapistCard = ({ therapist, onClick }) => {
  return (
    <div 
      className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer group flex flex-col h-full"
      onClick={() => onClick(therapist)}
    >
      {/* Bild */}
      <div className="aspect-square bg-gradient-to-br from-neutral-50 to-brand-accent relative overflow-hidden">
        {therapist.image && therapist.image !== "/api/placeholder/300/300" ? (
          <img 
            src={therapist.image} 
            alt={therapist.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon name="user-round" size={80} className="text-gray-300" />
          </div>
        )}
        {/* Placeholder för riktig bild senare */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/20 to-transparent h-1/3"></div>
      </div>
      
      {/* Innehåll */}
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex-grow">
          <h3 className="text-xl font-semibold text-primary mb-1 group-hover:text-brand-primary transition-colors">
            {therapist.name}
          </h3>
          <p className="text-sm text-brand-primary font-medium mb-3">
            {therapist.title}
          </p>
          
          {/* Specialiteter */}
          <div className="flex flex-wrap gap-1 mb-4">
            {therapist.specialties.slice(0, 3).map((specialty, index) => (
              <span 
                key={index}
                className="inline-block bg-neutral-100 text-text-secondary text-xs px-2 py-1 rounded-md border border-neutral-200"
              >
                {specialty}
              </span>
            ))}
          </div>
          
          {/* Kort bio */}
          <p className="text-text-secondary text-sm leading-relaxed mb-4 line-clamp-3">
            {therapist.shortBio}
          </p>
        </div>
        
        {/* Bottom aligned content */}
        <div className="mt-auto">
          {/* Metadata */}
          <div className="flex items-center justify-center text-xs text-neutral-400 mb-4">
            <div className="flex items-center gap-1">
              <Icon name="globe" size={14} />
              <span>{therapist.languages.join(', ')}</span>
            </div>
          </div>
          
          {/* Läs mer knapp */}
          <button className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-brand-primary-100 text-brand-primary rounded-lg hover:bg-brand-primary-200 transition-colors text-sm font-medium">
            <span>Läs mer</span>
            <Icon name="arrow-right" size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

const TherapistsPage = () => {
  const navigate = useNavigate();

    const handleTherapistClick = (therapist) => {
    trackEvent('Therapist Profile Click', {
      therapist_id: therapist.id,
      therapist_name: therapist.name,
      therapist_slug: therapist.slug
    });
    navigate(`/therapist/${therapist.slug}`);
  };

  return (
    <div className="min-h-screen ai-bg">
      <PublicNavbar />
      
      <div className="max-w-7xl mx-auto px-6 py-12 pt-24">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            Våra <span className="text-brand-primary">terapeuter</span>
          </h1>
          <p className="text-xl text-secondary max-w-3xl mx-auto leading-relaxed">
            Våra terapeuter är legitimerade av Socialstyrelsen och har lång erfarenhet att hjälpa människor att stärka sin självkänsla och bygga meningsfulla relationer.
          </p>
        </div>

        

        {/* Terapeuter Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {therapists.map((therapist) => (
            <TherapistCard 
              key={therapist.id} 
              therapist={therapist} 
              onClick={handleTherapistClick}
            />
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-primary mb-4">
              Redo att börja din resa?
            </h3>
            <p className="text-text-secondary mb-6">
              Vårt AI-system hjälper dig att hitta rätt terapeut baserat på dina behov och preferenser.
            </p>
            <button 
              onClick={() => {
                trackEvent('Start Chat Button Click', { location: 'therapists-page-cta' });
                navigate('/instant-chat');
              }}
              className="inline-flex items-center gap-2 px-8 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-dark transition-colors font-medium"
            >
              <Icon name="message-circle" size={20} />
              <span>Starta din första session</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TherapistsPage;